import React from 'react'
import Input from 'components/common/Input/Input'
import styles from './SubscribeButton.module.scss'
import { FlexColumn, FlexRow } from 'components/common/Containers'
import { Select } from 'components/common/Select'
import { Button } from 'components/common/Buttons/Button'
import classNames from 'classnames'

interface Props {
  email: string
  interval: string
  setInterval: React.Dispatch<React.SetStateAction<string>>
  onSubmit: () => void
  isLoading: boolean
}

const subscribeOptions = [
  {
    value: 'daily',
    label: 'Daily',
  },
  {
    value: 'weekly',
    label: 'Weekly',
  },
  {
    value: 'monthly',
    label: 'Monthly',
  },
]

const SubscribeButton: React.FC<Props> = ({
  email,
  interval,
  setInterval,
  onSubmit,
  isLoading,
}) => {
  return (
    <>
      <FlexRow className={classNames(styles.wrapper, styles.onlyMdUp)}>
        <Input
          wrapperClassName={styles.inputWrapper}
          className={styles.input}
          value={email || ''}
          isFormik={false}
          onChange={() => {}} // input value is unchangeable
        />
        <Select
          value={interval}
          className={styles.select}
          wrapperClassName={styles.selectWrapper}
          options={subscribeOptions}
          onChange={(e) => setInterval(e.target.value)}
        />
        <Button loading={isLoading} onClick={onSubmit}>
          Subscribe
        </Button>
      </FlexRow>

      <FlexColumn
        className={classNames(styles.mobileWrapper, styles.onlyMdDown)}
        align="normal"
        gap="10px"
      >
        <Input
          className={styles.input}
          value={email || ''}
          isFormik={false}
          onChange={() => {}} // input value is unchangeable
        />
        <Select
          className={styles.select}
          value={interval}
          options={subscribeOptions}
          onChange={(e) => setInterval(e.target.value)}
        />
        <Button loading={isLoading} onClick={onSubmit}>
          Subscribe
        </Button>
      </FlexColumn>
    </>
  )
}

export default SubscribeButton
